import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import ItemGroupsActions from "../../../store/actions/items/categories/itemGroups/itemGroups.actions";
import productActions from "../../../store/actions/items/item.actions";
import { productModel } from "../../../models/items/product.model";
import { SkeletonSelect } from "../../../components/general/skeleton";
import useDelayedFlag from "../../../hooks/useDelayedFlag";

export const AddProductPageComponent = ({ productActions, categoryActions }) => {
  const [productDetails, setProductDetails] = useState(productModel);
  const [categories, setCategories] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const showCategoriesSkeleton = useDelayedFlag(categoriesLoading);

  // Fetch categories on page load
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setCategoriesLoading(true);
    try {
      const response = await categoryActions.getCategories({ pageSize: 1000 }); // Fetch all categories
      setCategories(response.payload.items || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setCategoriesLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setProductDetails({
      ...productDetails,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddProduct = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setSuccessMessage("");
    setErrors({});
    try {
      const response = await productActions.addProduct(productDetails);
      setSuccessMessage("Product added successfully!");
      setProductDetails(productModel); // Reset the form
    } catch (error) {
      setErrors(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>Add Product</h2>

      {successMessage && <p style={{ color: "#663333" }}>{successMessage}</p>}
      {errors.message && <p style={{ color: "red" }}>{errors.message}</p>}

      <form onSubmit={handleAddProduct}>
        <div>
          <label>Product Name:</label>
          <input
            type="text"
            name="productName"
            value={productDetails.productName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div>
          <label>Description:</label>
          <textarea
            name="description"
            value={productDetails.description}
            onChange={handleInputChange}
            required
          />
        </div>

        <div>
          <label>
            Is Pre-Weighted:
            <input
              type="checkbox"
              name="isPreWeighted"
              checked={productDetails.isPreWeighted}
              onChange={handleInputChange}
            />
          </label>
        </div>

        {productDetails.isPreWeighted && (
          <div>
            <label>Default Weight (kg):</label>
            <input
              type="number"
              name="defaultWeight"
              value={productDetails.defaultWeight || ""}
              onChange={handleInputChange}
              required
            />
          </div>
        )}

        {categoriesLoading ? (
          showCategoriesSkeleton && <SkeletonSelect />
        ) : (
          <div>
            <label>Category:</label>
            <select
              name="categoryId"
              value={productDetails.categoryId}
              onChange={handleInputChange}
              required
            >
              <option value="">Select a category</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>
        )}

        <div>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Adding..." : "Add Product"}
          </button>
        </div>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    productActions: bindActionCreators(productActions, dispatch),
    categoryActions: bindActionCreators(ItemGroupsActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(AddProductPageComponent);
